import {FloatButton, Modal} from "antd";
import Icons from "./icons/Icons";
import ContactUs from "./modals/ContactUs";
import Feedback from "./modals/Feedback";
import React, {useState} from "react";
import html2canvas from "html2canvas";
import {checkBind, checkLogin} from "../util/login";

export default ({showAI, aiCollapsed, setAiCollapsed, authInfo, yuque=false, lang, code, preview}) => {

  const [showContactUs, setShowContactUs] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false)

  const handleCaptureAndCopy = async () => {
    try {
      if (document.hasFocus()) {
        html2canvas(document.getElementById("acm")).then(canvas => {
          canvas.toBlob(blob => {
            if (blob && document.hasFocus()) { // 再次确认焦点
              navigator.clipboard.write([
                new ClipboardItem({ "image/png": blob })
              ]);
              alert("✅ 当前屏幕截图已复制到剪贴板，粘贴 (Ctrl+V) 试试");
            }
          });
        });
      } else {
        alert("请点击页面后再试一次");
      }
    } catch (err) {
      console.error("截图失败:", err);
      alert("❌ 截图失败");
    }
  };

  return (
  <>
      <FloatButton.Group shape="circle" style={{ bottom: "30vh", transform: "translate(0%, 50%)"}}>
        {(showAI && aiCollapsed) ? <FloatButton icon={<Icons.Wink size="24px" className="absolute-center"/>}
                                                tooltip={{
                                                  title: '智能助理',
                                                  placement: 'left',
                                                }}
                                                onClick={()=>{
                                                  setAiCollapsed(false)
                                                }}
        />:<></>}
        {yuque || <FloatButton icon={<Icons.Scissors size="20px" className="absolute-center"/>}
                     tooltip={{
                       title: '截图',
                       placement: 'left',
                     }}
                     onClick={handleCaptureAndCopy}
        />}
        <FloatButton.Group
          trigger="hover"
          icon={<Icons.CustomerService size="22px" className="absolute-center"/>}
          placement="left"
          style={{
            position: "static",
          }}
        >
          <FloatButton icon={<Icons.ChatBubble size="22px" className="absolute-center"/>}
                       tooltip={{
                         title: '联系我们',
                         placement: 'top',
                       }}
                       onClick={()=>{
                         setShowContactUs(true)
                       }}
          />
          <FloatButton icon={<Icons.EditSheet size="20px" className="absolute-center"/>}
                       tooltip={{
                         title: '问题反馈',
                         placement: 'top',
                       }}
                       onClick={()=>{
                         if(!checkLogin(authInfo, yuque)) return
                         checkBind(authInfo)
                         setShowFeedback(true)
                       }}
          />
        </FloatButton.Group>

      </FloatButton.Group>
    <Modal
      title="联系我们"
      open={showContactUs}
      onCancel={()=>{setShowContactUs(false)}}
      footer={null}
    >
      <ContactUs/>
    </Modal>
    <Modal
      title="问题反馈"
      open={showFeedback}
      onCancel={()=>{setShowFeedback(false)}}
      footer={null}
    >
      <Feedback closeMe={()=>{setShowFeedback(false)}} token={authInfo?.token} lang={lang} code={code} preview={preview}/>
    </Modal>
  </>
  )
}